import * as React from 'react'

export function useThrottledCallback<A,>(func: (...args: A[]) => void, wait: number): () => void {
  const lastCall = React.useRef<number>(0)

  return React.useCallback(
    (...args: A[]) => {
      const now = Date.now()
      if (now - lastCall.current >= wait) {
        lastCall.current = now
        func(...args)
      }
    },
    [func, wait],
  )
}
